export default __webpack_public_path__ + "static/media/integration-tile-logo.5b40b376.png";